import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Calendar, Check, IsOpen, Times } from '../../../components/Icon';
import { COLOR_SECONDARY_1 } from '../../../vars';
import { deleteVehicleProperty, setVehicleProperty } from '../actions';
import { selectMe, selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTIES, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import _, { isDate } from 'lodash';
import dayjs from 'dayjs';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import cn from 'classnames';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './cardHooicardInslag.module.css';

import { fetchAddress } from '../../Address/actions';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import { translateCountry } from '../../Companies/translate-countries';
import { fetchCompany } from '../../Companies/actions';
import { selectHomeCompany } from '../../Companies/selectors';
import { AddPhotoButton } from '../../../components/AddPhotoButton';
import { resizeAndRotate } from '../../../utils/image';
import { addMultipleDocs, deleteDocument } from '../../Documents/actions';
import { REQUEST_ADD_MULTIPLE_DOCUMENTS, REQUEST_USER } from '../../Users/constants';
import { fetchUser } from '../../Users/actions';
import { selectUser } from '../../Users/selectors';
import { WithUser } from '../../Users/components/WithUser';
import { CompanyLabelById } from '../../Companies/components/CompanyLabelById';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import LoadingField from '../../../containers/App/Components/LoadingField/LoadingField';
import { REQUEST_ADDRESS } from '../../Address/constants';
import { Textarea } from '../../../components/Textarea';
import { getPropByName } from '../../../utils/props';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { isMobileDevice } from '../../../utils/checkDevice';

dayjs.extend(customParseFormat);

const getCurrentDate = () => dayjs().format('DD-MM-YYYY HH:mm');

const Container = styled.div`
  .started {
    margin: 12px 0;
    font-weight: 600;
  }
  .sub-title {
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
    width: 100%;
    margin: 12px 0 0;
  }
  .address {
    border: 1px solid #ddd;
    border-radius: 12px;
    padding: 12px;
    margin: 12px;
    .name {
      font-weight: 600;
    }

    &.selected {
      border: 2px solid ${COLOR_SECONDARY_1};
    }
  }
  .dropdown-block {
    min-height: 300px;
  }

  .dropdown {
    min-width: 250px;
  }
`;

const Address = styled.div`
  border: ${props => (!!props.isActive ? '1px solid rgb(21, 172, 121)' : '1px solid grey')};
  border-radius: 6px;
  padding: 12px;
  width: calc(50% - 10px);
  margin: 6px 0;
  font-size: 12px;
  min-height: 118px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const ImagePreview = styled.div`
  width: 33%;
  height: 120px;
  flex-shrink: 0;
  background-size: cover;
  background-position: center center;
`;

const STATE = {
  init: false,
  inslagModal: false,
  isOpen: true,
  showNotification: false,
  remarks: [],
  newRemarkText: '',
  editableRemark: null,
  currentLocation: null,
  companyAddresses: null,
  inslagImage: null,
  HOOI_inslag_done_date: getCurrentDate(),
};

/* eslint-disable react/prefer-stateless-function */
class VehicleHooicardInslagComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      inslagModal: props.showModal || false, // Initialize based on the `showModal` prop
    });
    this.state = {
      ...STATE,
      remarks: [], // Initialize as an empty array
    };
  }

  VehicleHooicardInslagComp(props) {
    const { showModal, onCloseModal } = props;

    console.log('showModal:', showModal);

    useEffect(() => {
      if (showModal) {
        setState({ inslagModal: true });
      }
    }, [showModal]);
    return (
      <>
        {inslagModal && (
          <ModalComponent onClose={onCloseModal} title="Voertuig inslag">
            ret
          </ModalComponent>
        )}
      </>
    );
  }

  componentDidMount() {
    this.vehicle?.remarks && this.setState({ remarks: JSON.parse(this.vehicle?.remarks) });
    this.props.fetch();
    if (this.vehicle?.HOOI_inslag_done_date) {
      this.setState({
        HOOI_inslag_done_date: this.vehicle?.HOOI_inslag_done_date,
      });
    } else {
      this.setState({
        HOOI_inslag_done_date: getCurrentDate(),
      });
    }
    if (this.vehicle?.HOOI_inslag_done_user_id) {
      this.setState({
        HOOI_inslag_done_user_id: this.vehicle?.HOOI_inslag_done_user_id,
      });
    }

    this.props.fetchAddress(this.vehicle.location_address_id, result => {
      if (result?.id) {
        this.setState({ currentLocation: result });
        if (this.vehicle?.HOOI_inslag_done_user_id && this.vehicle?.HOOI_inslag_done_date) {
          this.setState({ selectedAddress: result });
        }
      }
    });
    this.props.fetchHomeCompany(this.props.homeCompanyId, res => {
      if (res?.id) {
        this.setState({
          companyAddresses: res?.addresses,
          defaultAddresses: res?.addresses,
          company: res,
        });
      }
    });
  }

  applyDisabled() {
    let disabled = false;

    if (env.clientId === AppClientId.HOOIKAMMER) {
      disabled = true;
    }

    return disabled;
  }

  getActionIdByName(name) {
    return this.props?.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.showModal !== this.props.showModal) {
      this.setState({ inslagModal: this.props.showModal });
    }
    if (
      this.vehicle?.HOOI_inslag_done_date &&
      prevProps.vehicle?.HOOI_inslag_done_date !== this.vehicle?.HOOI_inslag_done_date
    ) {
      this.setState({
        HOOI_inslag_done_date: this.vehicle?.HOOI_inslag_done_date,
      });
    }

    if (
      (this.vehicle?.location_address_id && !this.state.currentLocation) ||
      this.vehicle?.location_address_id !== prevProps.vehicle?.location_address_id
    ) {
      this.props.fetchAddress(this.vehicle.location_address_id, result => {
        if (result?.id) {
          this.setState({ currentLocation: result });
          if (this.vehicle?.HOOI_inslag_done_user_id && this.vehicle?.HOOI_inslag_done_date) {
            this.setState({ selectedAddress: result });
          }
        }
      });
    }
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get locale() {
    return this.props.locale;
  }

  get inslagDoneDto() {
    const dto = {
      HOOI_inslag_done_date: this.state.HOOI_inslag_done_date,
      HOOI_inslag_done_user_id: this.props.me?.id,
      location_address_id: this.state.selectedAddress?.id,
      HOOI_inslag_done_image: this.multiPhotosDto(),
    };
    return dto;
  }

  get inslagBtnLabel() {
    let label = 'Inslag';
    if (this.vehicle?.HOOI_inslag_done_date && this.vehicle?.HOOI_inslag_done_user_id) {
      label = 'Inslag voltooid';
    }

    return label;
  }

  handleDeleteInslag = () => {
    const { deleteInslag, vehicle } = this.props;
    deleteInslag(vehicle.id);
  };

  multiPhotosDto() {
    if (!this.state.inslagImage) return {};
    let initialDto = {
      files: [],
      docs: [],
      entities: [{ entitiId: this.vehicle?.id, entitiType: 'vehicle' }],
    };

    let dto = [this.state.inslagImage]?.reduce((acc, curr) => {
      acc.files?.push(curr.file);
      acc.docs?.push({
        name: `HOOI_inslag_done_image`,
        type: `HOOI_inslag_done_image`,
        originalFilename: 'originalFilename',
      });
      return acc;
    }, initialDto);

    return dto;
  }

  capture(name, callback, setToLocalState) {
    //remove existing image upload
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';
    // input.setAttribute('capture', 'camera');

    if (isMobileDevice()) {
      input.setAttribute('capture', 'environment');
    }

    document.body.appendChild(input);

    input.click();

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          this.setState(prev => ({
            inslagImage: {
              id: Date.now(),
              name,
              type: 'photo_interior_' + name,
              originalFilename: 'originalFilename',
              file: file,
              url: URL.createObjectURL(evt.target.files[0]),
            },
          }));

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  onSelectCompany(company) {
    this.setState({ company: company, active: false, companyAddresses: company?.addresses });
  }

  handleSetAddress = a => {
    this.setState({ selectedAddress: a });
  };

  onSetInslag(n) {
    this.setState({ inslagModal: false });

    this.props.inslagDone(this.inslagDoneDto, this.reset.bind(this));
  }

  datePicker(type, disabled) {
    let format = this.state[type]?.charAt?.(2) == '-' ? 'DD-MM-YYYY HH:mm' : undefined;

    let selected = this.state[type] && this.state[type] !== 'null' && dayjs(this.state[type], format);

    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          disabled={disabled}
          className={styles.datePicker}
          showTimeInput
          dateFormat="dd-MM-yyyy HH:mm"
          timeFormat="HH:mm"
          selected={selected && selected != 'Invalid Date' && selected.toDate()}
          onChange={date => {
            let d = dayjs(date).format('DD-MM-YYYY HH:mm');
            this.setState({ [type]: d, showEditDate: true });
          }}
        />
        <Calendar className={styles.iconCalendar} />
      </div>
    );
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }

  get sortingDate() {
    return new Date(Date.now());
  }

  onSave() {
    const remark = {
      id: Date.now(),
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const remarks = [...this.state.remarks, remark];
    this.setState({ remarks }); // Immediate state update for UI responsiveness

    this.props.setRemark(JSON.stringify(remarks), result => {
      // if (result) {
      //   this.reset();
      // }
    });
  }

  onEdit(remarkId) {
    const remark = {
      id: remarkId,
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const remarks = this.state.remarks?.filter(remark => remark?.id != remarkId);
    const updatedRemarks = [...remarks, remark];

    this.props.setRemark(JSON.stringify(updatedRemarks));
  }

  onDelete(remarkId) {
    const remarks = this.state.remarks?.filter(remark => remark?.id != remarkId);

    this.props.setRemark(JSON.stringify(remarks));
  }

  reset() {
    // Reset local state
    this.setState(prev => ({
      init: false,
      inslagModal: false,
      isOpen: true,
      companyAddresses: prev.defaultAddresses,
      inslagImage: null,
      HOOI_inslag_done_date: this.vehicle?.HOOI_inslag_done_date ?? getCurrentDate(),
    }));

    // Call the parent's reset function, if provided
    if (this.props.onResetParentState) {
      this.props.onResetParentState();
    }
  }

  renderNotification() {
    return (
      <ModalComponent onClose={() => this.setState({ showNotification: false })}>
        <VBox className="d-flex gap-2">
          {/* <ButtonComponent
            style="ButtonSoftPrimaryFullWidth"
            disabled={this.applyDisabled()}
            onClick={() => {
              console.log(this.state.showNotification + 'notificationclick');
              this.setState({ showActionModal: true });
            }}
          >
            {this.lbl('vehicle.label_printer.notification.check_and_print')}
          </ButtonComponent> */}
          <ButtonComponent
            style="ButtonSoftPrimaryFullWidth"
            onClick={() => {
              console.log(this.state.showNotification + 'notificationclick');
              this.props.print(res => {
                this.setState({ showNotification: false });
              });
            }}
          >
            {console.log(this.state.showNotification + 'notification')}
            {this.lbl('vehicle.label_printer.notification.print_only')}
          </ButtonComponent>
          {/* <ButtonComponent
            style="ButtonSoftPrimaryFullWidth"
            disabled={this.applyDisabled()}
            onClick={() => {
              console.log(this.state.showNotification + 'notificationclick');
              this.props.taskLabelComplete(res => {
                this.setState({ showNotification: false });
              });
            }}
          >
            {this.lbl('vehicle.label_printer.notification.task_labels')}
          </ButtonComponent> */}
        </VBox>
      </ModalComponent>
    );
  }

  render() {
    if (this.props.work)
      return (
        <Card className={cn('vehicle-info-card info-card data', styles.card)}>
          <LoadingField />
          <LoadingField />
          <LoadingField />
        </Card>
      );

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        {this.state.showNotification && this.renderNotification()}
        <Container className={'modal-inner'}>
          <HBox>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.inslag')}</h2>
            {window.innerWidth <= 768 && (
              <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>
            )}
          </HBox>
          <div className="mb-3">
            {(this.state.isOpen || window.innerWidth > 768) && (
              <>
                <div className="d-flex flex-column gap-2">
                  <ButtonComponent
                    style={'ButtonSoftPrimaryFullWidth'}
                    onClick={() => {
                      if (!this.vehicle?.HOOI_inslag_done_date) {
                        this.setState({ HOOI_inslag_done_date: getCurrentDate() });
                      }
                      this.setState({ inslagModal: true });
                    }}
                  >
                    {this.inslagBtnLabel}
                  </ButtonComponent>
                  {this.vehicle.HOOI_inslag_done_date && !this.vehicle.HOOI_uitslag_done_date && (
                    <ButtonComponent
                      style={'ButtonSoftDelete'}
                      onClick={() => {
                        if (window.confirm('Weet u het zeker?')) {
                          this.handleDeleteInslag();
                        }
                      }}
                    >
                      {this.lbl('vehicle.details.option.modal.deleteBtn')}
                    </ButtonComponent>
                  )}
                </div>

                {this.renderModal()}
              </>
            )}
          </div>
          <span>
            Ingeslagen door:{' '}
            {
              <WithUser label user_id={this.vehicle?.HOOI_inslag_done_user_id}>{`${this.props.user?.name ?? ''} ${this.props
                .user?.surname ?? ''}`}</WithUser>
            }
          </span>

          <div className="d-flex gap-2">
            <label className="form-label">Inslagdatum: </label>
            <span>{this.vehicle?.HOOI_inslag_done_date ? `${this.vehicle?.HOOI_inslag_done_date} u` : ''}</span>
          </div>
        </Container>
      </Card>
    );
  }

  renderModal() {
    if (this.state.inslagModal) return this.renderInslagModal();
    if (!this.state.init) return null;
  }

  renderAddModal() {
    return (
      <>
        <Textarea
          value={this.state.newRemarkText}
          onChange={e => this.setState({ newRemarkText: e.target?.value })}
          label={this.state.editableRemark ? this.lbl('info.remarks.edit') : this.lbl('info.remarks.add')}
        />
      </>
    );
  }

  renderInslagModal() {
    return (
      <ModalComponent onClose={this.reset.bind(this)} title="Voertuig inslag">
        <VBox className={styles.containerForm}>
          {this.datePicker('HOOI_inslag_done_date')}
          <div style={{ width: '100%' }} className="mb-3">
            <ButtonComponent
              style={'ButtonSoftPrimaryFullWidth'}
              disabled={this.props.disabled}
              onClick={this.setStateFn(prev => ({
                active: true,
                company: null,
                selectedAddress: null,
                companyAddresses: prev.defaultAddresses,
              }))}
            >
              {this.lbl('vehicle.select_relation')}
            </ButtonComponent>
          </div>
          <div className="mb-2 w-100">
            {this.state.company && !this.state.active ? (
              <CompanyLabelById company_id={this.state.company?.id} key={this.state.company?.id} fetchName />
            ) : (
              <CompanySelection onSelect={company => this.onSelectCompany(company)} company={this.state.company} />
            )}
          </div>
          <span> {this.lbl('vehicle.current_location')}</span>

          <HBox vCenter left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }}>
            {this.state.currentLocation && (
              <Address
                key={`${this.state.currentLocation?.id}`}
                onClick={() => this.handleSetAddress(this.state.currentLocation)}
                isActive={this.state.selectedAddress?.id === this.state.currentLocation?.id}
              >
                <VBox left>
                  <HBox vCenter gap={'10px'}>
                    {this.state.currentLocation?.name && (
                      <ButtonComponent style={'ButtonSoftPrimary'}>
                        <h6 className="name">{this.state.currentLocation?.name}</h6>
                      </ButtonComponent>
                    )}
                    <CheckboxComponent checked={this.state.selectedAddress?.id === this.state.currentLocation?.id} />
                  </HBox>
                  <VBox className="address" left>
                    <div>{this.state.currentLocation?.addressLine1}</div>
                    <div>
                      {this.state.currentLocation?.postcode} {this.state.currentLocation?.city}
                    </div>
                    <div>{translateCountry(this.state.currentLocation.country?.name, this.locale)}</div>
                  </VBox>
                </VBox>
              </Address>
            )}
          </HBox>
          <span> {this.lbl('vehicle.location')}</span>
          <HBox vCenter left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }}>
            {this.state.companyAddresses?.map(
              address =>
                address && (
                  <Address
                    key={`${address?.id}`}
                    onClick={() => this.handleSetAddress(address)}
                    isActive={this.state.selectedAddress?.id === address?.id}
                  >
                    <VBox left>
                      <HBox vCenter gap={'10px'}>
                        {address?.name && (
                          <ButtonComponent style={'ButtonSoftPrimary'}>
                            <h6 className="name">{address?.name}</h6>
                          </ButtonComponent>
                        )}
                        <CheckboxComponent checked={this.state.selectedAddress?.id === address?.id} />
                      </HBox>
                      <VBox className="address" left>
                        <div>{address?.addressLine1}</div>
                        <div>
                          {address?.postcode} {address?.city}
                        </div>
                        <div>{translateCountry(address?.country?.name, this.locale)}</div>
                      </VBox>
                    </VBox>
                  </Address>
                ),
            )}
          </HBox>
          <div style={{ width: '100%' }}>{this.renderAddModal()}</div>
          <AddPhotoButton
            onUpload={e => this.capture('HOOI_inslag_done_image', this.props.refresh, true)}
            disabled={this.state.inslagImage}
          />

          {this.state.inslagImage && (
            <HBox>
              {[this.state.inslagImage]
                .filter(photo => photo?.url)
                ?.map(({ url, name, id }) => {
                  return (
                    <ImagePreview
                      key={url}
                      className="multi-img"
                      style={{ backgroundImage: `url('${url}')` }}
                    ></ImagePreview>
                  );
                })}
              <ButtonComponent style={'ButtonSoftDelete'} onClick={() => this.setState({ inslagImage: null })}>
                {<Times />}
              </ButtonComponent>
            </HBox>
          )}
          <ButtonComponent style="ButtonSoftEditFullWidth" onClick={this.setStateFn({ showNotification: true })}>
            {this.vehicle?.label_printer_queue == '2' ? (
              <>
                <Check />
                {this.lbl('vehicle.property.label_printer_queue.2')}
              </>
            ) : (
              this.lbl('vehicle.info.label.label')
            )}
          </ButtonComponent>
        </VBox>
        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={!this.state.selectedAddress?.id}
            onClick={() => {
              if (this.state.newRemarkText?.trim()) {
                if (this.state.editableRemark) {
                  this.onEdit(this.state.editableRemark);
                } else {
                  this.onSave();
                }
              }
              this.onSetInslag();
            }}
          >
            {this.lbl(`save`)}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
        <div></div>
      </ModalComponent>
    );
  }
}

VehicleHooicardInslagComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    locale: makeSelectLocale(),
    work: selectWorks([
      `${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicleId}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_ADD_MULTIPLE_DOCUMENTS,
      REQUEST_USER,
      `${REQUEST_ADDRESS}-${ownProps.vehicle.location_address_id}`,
    ]),
    loggedUser: selectUser(ownProps?.loggedUserId),
    homeCompanyId: selectHomeCompany(),
    me: selectMe(),
    user: selectUser(ownProps.vehicle?.HOOI_inslag_done_user_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    print(callback) {
      console.log('callback functie aangeroepen');
      dispatch(
        setVehicleProperty(ownProps?.vehicle?.id, 'label_printer_queue', '1', () => {
          console.log('callback VANUIT dispatch aangeroepen');
          callback?.();
        }),
      );
    },

    taskLabelComplete(callback) {
      dispatch(setVehicleProperty(ownProps?.vehicle?.id, 'task_labels', '0', callback));
    },

    async fetch() {
      if (!ownProps?.loggedUserId) {
        console.error('Error: userId not set');
        return;
      }

      try {
        await dispatch(fetchUser(ownProps?.loggedUserId));
      } catch (error) {
        console.error('Failed to fetch user:', error);
      }
    },
    setRemark(dto, callback) {
      dispatch(setVehicleProperty(ownProps?.vehicle?.id, 'remarks', dto, callback));
    },
    fetchAddress(id, callback) {
      dispatch(fetchAddress(id, callback));
    },
    fetchHomeCompany(companyId, callback) {
      dispatch(fetchCompany(companyId, callback));
    },
    fetchUser(id, callback) {
      dispatch(fetchUser(id, callback));
    },

    deleteInslag() {
      const inslagDoneImage = ownProps.vehicle.documents?.find(d => d.type === 'HOOI_inslag_done_image');
      if (inslagDoneImage?.id) {
        dispatch(deleteDocument(ownProps.vehicle.id, 'vehicle', inslagDoneImage?.id));
      }

      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'HOOI_inslag_done_date'));
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'HOOI_inslag_done_user_id'));

      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'location_address_id'));
    },

    inslagDone(dto = {}, callback, work) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'HOOI_inslag_done_date', dto.HOOI_inslag_done_date, callback));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'HOOI_inslag_done_user_id', dto.HOOI_inslag_done_user_id, callback));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_address_id', dto.location_address_id, callback));
      if (dto.HOOI_inslag_done_image?.docs?.length) {
        dispatch(addMultipleDocs(ownProps.vehicle?.id, 'vehicle', dto.HOOI_inslag_done_image, callback));
      }
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleHooicardInslag = compose(withConnect, withRouter)(VehicleHooicardInslagComp);
